import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VImg,
  VAvatar,
  VBtn,
  VChip,
  VList,
  VSubheader,
  VSelect,
  VIcon,
  VBottomNav,
  VTextField,
  VDialog,
  VToolbar,
  VTabs,
  VCard,
  VProgressLinear,
  VProgressCircular,
  VDivider,
  VTooltip,
  VSwitch,
  VStepper,
  VSnackbar,
  transitions
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'
import { Ripple } from 'vuetify/es5/directives'

const MY_ICONS = {
  'dropdown': 'fas fa-caret-down',
  'triangle': 'fas fa-triangle',
  'edit': 'fas fa-pencil',
  'complete': 'fas fa-check',
  'close': 'fas fa-times',
  'share-alt': 'fas fa-share-alt',
  'copy': 'fas fa-copy',
  'loading': 'fas fa-spinner-third'
}

Vue.use(Vuetify, {
  components: {
    VApp,
    VImg,
    VAvatar,
    VBtn,
    VChip,
    VList,
    VSubheader,
    VSelect,
    VIcon,
    VBottomNav,
    VTextField,
    VDialog,
    VToolbar,
    VTabs,
    VCard,
    VProgressLinear,
    VProgressCircular,
    VDivider,
    VTooltip,
    VSwitch,
    VStepper,
    VSnackbar,
    transitions
  },
  directives: {
    Ripple
  },
  iconfont: 'fa',
  icons: MY_ICONS,
  theme: {
    primary: '#116abf'
  }
})
